import { OPTION_SETS } from "./app-data.constants";

export const MaatNcqManagerDetermination = {

    SustainedDeterminations: new Set<string>([
        OPTION_SETS.maatNcq.ManagerDetermination.Sustained,
        OPTION_SETS.maatNcq.ManagerDetermination.SustainedInOneA,
        OPTION_SETS.maatNcq.ManagerDetermination.SustainedInOneB,
        OPTION_SETS.maatNcq.ManagerDetermination.SustainedInTwoA,
        OPTION_SETS.maatNcq.ManagerDetermination.SustainedInTwoB
    ])
};